const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api';

// Google Drive 連携はブラウザから直接 Google API を呼ぶため、ここには定義しない。
export const apiEndpoints = {
  pdfAnalyze: `${API_BASE_URL}/pdf/analyze`,
  pdfAnalyzeText: `${API_BASE_URL}/pdf/analyze-text`,
};

export { API_BASE_URL };